module.exports = __webpack_public_path__ + "static/media/3.ac173e5f.jpeg";